// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import firebase from 'firebase'
// import functions from 'firebase-functions'
import router from './router'

import {allcountries, has_subregions, continent_map} from "./data.js";
// import Buefy from 'buefy'

Vue.config.productionTip = false

// Vue.use(Buefy, {
//   defaultIconPack: 'fas'
// })

Object.defineProperty(Vue.prototype, '$firebase', { value: firebase });
// Object.defineProperty(Vue.prototype, '$firebaseui', { value: firebaseui });

firebase.initializeApp({
  // apiKey: 'AIzaSyDnP2WxGA_0oDOs67ZNS0ScUvaADP1ZR2I',
  // authDomain: 'lockdown-dashboard.firebaseapp.com',
  // projectId: 'lockdown-dashboard'
  apiKey: "AIzaSyA3pMq6nv8jdywJkKq2Ss2p_5H77dHZbmo",
  authDomain: "bike-trip-directory.firebaseapp.com",
  databaseURL: "https://bike-trip-directory.firebaseio.com",
  projectId: "bike-trip-directory",
  storageBucket: "bike-trip-directory.appspot.com",
  messagingSenderId: "166756220581",
  appId: "1:166756220581:web:db33be5fecabb48c12d74c",
  measurementId: "G-ZX449WPFD2"
  // storageBucket: 'gs://websites-for-everyone-d1a3b.appspot.com'
});


firebase.analytics();

Object.defineProperty(Vue.prototype, '$titleTemplate', { value: '%s | BikeSleepBike' });

var needsThe = ['Great Divide Mountain Bike Route', 'United States', 'United Kingdom', 'Baja Divide', 'Colorado Trail', 'Arizona Trail', "TransAmerica"];
Object.defineProperty(Vue.prototype, '$maybeThe', { value: function(str) {
  if (needsThe.includes(str)) {
    return 'The';
  } else { return ''; }
  
} });

const imageBase = "https://firebasestorage.googleapis.com/v0/b/bike-trip-directory.appspot.com/o/images%2F";
Object.defineProperty(Vue.prototype, '$imageBase', { value: imageBase });

var routeWithoutThe = ['Cairo to Cape Town', 'Alaska to Ushuaia', 'Bike Nonstop US', 'The Big Lonely'];
Object.defineProperty(Vue.prototype, '$noThe', { value: function(str) {
  if (routeWithoutThe.includes(str)) {
    return true;
  } else { return false; }
  
} });

var affiliateDisclosure = "Some book links are affiliate links, which means BikeSleepBike may earn a small commission at no extra cost to you if you buy something through them. The money helps pay for hosting and infrastructure costs of running this website. As an Amazon Associate I earn from qualifying purchases. Thanks!"
Object.defineProperty(Vue.prototype, '$affiliateDisclosure', { value: affiliateDisclosure });

var db = firebase.firestore();
Object.defineProperty(Vue.prototype, '$db', { value: db });

var debug = false;
Object.defineProperty(Vue.prototype, '$debug', { value: debug });

Object.defineProperty(Vue.prototype, '$countrymap', { value: allcountries });

function hasSubregions(countryCode) {
  return has_subregions.includes(countryCode);
}
Object.defineProperty(Vue.prototype, '$hasSubregions', { value: hasSubregions });


function getCodeFromCountry(inputName) {
  if (inputName) {
    for (const code in this.$countrymap) {
      if (this.$countrymap[code].toLowerCase() == inputName.toLowerCase()) {
          return code;
      }
    } 
  }
  
  return "";
}
Object.defineProperty(Vue.prototype, '$getCodeFromCountry', { value: getCodeFromCountry });

function getUser() {
  return this.$getParent('App').user; 
}
Object.defineProperty(Vue.prototype, '$getUser', { value: getUser });

function isAdmin() {
  return (this.$getParent('App').user.email == 'alissa.w.bell@gmail.com');
}
Object.defineProperty(Vue.prototype, '$isAdmin', { value: isAdmin });

// console.log("Signing in");
// firebase.auth().signInAnonymously().catch(function(error) {
//   // Handle Errors here.
//   var errorCode = error.code;
//   var errorMessage = error.message;
//   console.log("Anon login" + errorMessage);
//   // ...
// });
var totals = {};
// console.log("Getting totals");
db.collection("counts").doc("totals").get()
  .then(function(doc) {
      if (doc.exists){
        if (debug) {
        }
        totals = doc.data();
      }
  }).catch(function(error) {
      console.error("Error fetching totals: ", error);
  });
function getTotals() {
  // console.log(totals);
  return totals;
}
function setTotals(totalsObj) {
  totalsObj = totals;
}
Object.defineProperty(Vue.prototype, '$getTotals', { value: getTotals });
Object.defineProperty(Vue.prototype, '$setTotals', { value: setTotals });

// // Load routes
// var allRoutes = {};
// db.collection("routes").get()
//   .then(function(querySnapshot) {
//       // allRoutes = querySnapshot.doc.data();
//       querySnapshot.forEach(function(doc) {
//         // console.log(doc.data());
//         allRoutes[doc.id] = doc.data();
//       });
//       console.log(allRoutes);
//   }).catch(function(error) {
//       console.error("Error fetching routes: ", error);
//   });
//   function getAllRoutes() {
//     return allRoutes;
//   }
//   Object.defineProperty(Vue.prototype, '$getAllRoutes', { value: getAllRoutes });


function titleCase(str) {   //NOTE: there's a copy of this in cloud functions file
  if (str) {
     //   console.log(str);
  str = str.toLowerCase();
  str = str.split(' ');
  // console.log(str);
  var noCapitalizeWords = ['to', 'of', 'the', "'n'", 'de', 'del', 'du', 'las', 'los'];
  var capitalizeAfterChar = ['-', '('];  // special case for Pan-American Highway, Trans Canada Trail (Great Trail), and similar
  // var noCapitalizeIfIncludes = ['-'];
  for (var i = 0; i < str.length; i++) {
    if ( !noCapitalizeWords.includes(str[i]) ) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
      // console.log(str[i]);
    }
    for (var j = 0; j < capitalizeAfterChar.length; j++) {
      var character = capitalizeAfterChar[j];
      // console.log(str[i]);
      if (str[i].indexOf(character) >= 0) { 
        // console.log(character);
        var idx = str[i].indexOf(character);
        // console.log(str[i].slice(0,idx-1));
        str[i] = str[i].slice(0,idx) + str[i].charAt(idx) + str[i].charAt(idx+1).toUpperCase() + str[i].slice(idx+2);
      }
    }
    
  }
  return str.join(' ');
  } else {
    return '';
  }
 
}
Object.defineProperty(Vue.prototype, '$titleCase', { value: titleCase });

function doTheStuff() {
  console.log("Getting totals inside function that's called after init");
  db.collection("counts").doc("totals").get()
    .then(function(doc) {
        if (doc.exists){
          if (debug) {
            console.log("Got totals",doc);
          }
            // console.log(doc.data());
            totals = doc.data();
        }
    }).catch(function(error) {
        console.error("Error fetching totals: ", error);
    });
}

function keyify(str){
  var result = "";
  if (str) {
    var result = encodeURIComponent(str.toLowerCase());
  }
  return result;
}
Object.defineProperty(Vue.prototype, '$keyify', { value: keyify });



var keyificationExceptions = { //NOTE: there's a copy of this in cloud functions file
  'transamerica': 'TransAmerica',
  'pan-american highway': 'Pan-American Highway',
  'bike nonstop us': 'Bike Nonstop US',
  'c&o canal trail': 'C&O Canal Trail',
  'the big lonely': "The Big Lonely",
  'socal desert ramble': 'SoCal Desert Ramble'
 
};


function unkeyify(str){  //NOTE: there's a copy of this in cloud functions file
  var result = "";
  // console.log("Unkeyifying", str);
  result = decodeURIComponent(str);
  var resultLowerCase = result.toLowerCase();
  // console.log("Decoded URI: ", result);
  if (keyificationExceptions.hasOwnProperty(resultLowerCase) ) {
    result = keyificationExceptions[resultLowerCase];
    // console.log(result);
  } else {
    result = titleCase(result);
  }
    
  
  // console.log("UNKEYIFIED str:", result);
  return result;
}
Object.defineProperty(Vue.prototype, '$unkeyify', { value: unkeyify });

// Required for side-effects
// require("firebase/functions");
var functions = firebase.functions();
var analytics = firebase.analytics();
Object.defineProperty(Vue.prototype, '$analytics', { value: analytics });

function getParent(name){
  let p = this.$parent;
  while(typeof p !== 'undefined'){
    if(p.$options.name == name) {
      return p;
    }else {
      p = p.$parent;
    }
  }
  return false;
}
Object.defineProperty(Vue.prototype, '$getParent', { value: getParent });

var continents = ["Africa", "Asia", "Europe", "North America", "Oceania", "South America"];
Object.defineProperty(Vue.prototype, '$continentsArray', { value: continents });

function getContinentFromCountryCode(countrycode) {
  var match = continent_map.find(elem => elem["Two_Letter_Country_Code"] == countrycode);
  var continent = ""
  if (match && match["Continent_Name"]) {
    continent = match["Continent_Name"];
  }
  
  return continent;

}
Object.defineProperty(Vue.prototype, '$getContinentFromCountryCode', { value: getContinentFromCountryCode });

function writeDoc(collection, doc, fields, merge) {
  db.collection(collection).doc(doc).set(fields, { merge: merge })
    .then(function() {
      // console.log(fields);
        // console.log("Document successfully written!");
        // console.log(fields);
    })
    .catch(function(error) {
        // console.error("Error writing document: ", error);
    });
}
function writeDocGenId(collection, fields) {
  var that = this;
  db.collection(collection).add(fields)
    .then(function(docRef) {
      // console.log(fields);
        // console.log("Document successfully written with new ID " + docRef.id);
        // that[outname] = docRef.id;
        // console.log(fields);
    })
    .catch(function(error) {
        console.error("Error writing document: ", error);
    });
}
function fetchDoc(collection, doc, out) {
  var that = this;
  
  if (this.$debug) {
    console.log("DEBUG: In function fetchDoc")
    console.log(collection);
    console.log(doc);
  };
  this.$db.collection(collection).doc(doc)
  .onSnapshot(function(doc) {
    var data = doc.data();
      console.log("Current data in function fetchDoc: ", data);
      that[out] = data;
      // console.log(out);
  });
}
function fetchCollection(collection, outobj) {
  var that = this;
  var result = {};
  db.collection(collection).onSnapshot(function(querySnapshot) {
    querySnapshot.forEach(function(doc) {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        result[doc.id] = doc.data();
    });
    that[outobj] = result;
  });
}
function getQueryDocs(collection, fieldname, operator, condition, outname) {
  var that = this;
  console.log(fieldname + " " + operator + " " + condition); 
  db.collection(collection).where(fieldname, operator, condition)
    .get()
    .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            // console.log(that[outname]);
            that[outname].push(doc.data());
        });
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });

}


Object.defineProperty(Vue.prototype, '$writeDoc', { value: writeDoc});
Object.defineProperty(Vue.prototype, '$writeDocGenId', { value: writeDocGenId});
Object.defineProperty(Vue.prototype, '$fetchDoc', { value: fetchDoc});
Object.defineProperty(Vue.prototype, '$fetchCollection', { value: fetchCollection});
Object.defineProperty(Vue.prototype, '$getQueryDocs', { value: getQueryDocs});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js